// AUTO-GENERATED by scripts/process-press-photos.js — do not edit by hand.
// Re-run that script (node scripts/process-press-photos.js) after adding,
// removing, or re-categorizing photos in scripts/press-photos-manifest.js.

export const PRESS_PHOTOS = [
  {
    "name": "jop_headshot_dan-wella-diner",
    "category": "headshot",
    "alt": "Dan Drake and Wella Kelly seen through the window of Courtesy Diner in St. Louis — Dan in a yellow letterman jacket holding a coffee mug, Wella in an orange sweater laughing. A vintage jukebox sits to their right.",
    "featured": true,
    "slot": "bio-portrait",
    "width": 1080,
    "height": 720,
    "aspect": 1.5,
    "original": "press/photos/originals/headshot/jop_headshot_dan-wella-diner.jpg",
    "variants": {
      "600": "press/photos/web/headshot/jop_headshot_dan-wella-diner-600.jpg",
      "1200": "press/photos/web/headshot/jop_headshot_dan-wella-diner-1200.jpg",
      "2400": "press/photos/web/headshot/jop_headshot_dan-wella-diner-2400.jpg"
    }
  },
  {
    "name": "jop_headshot_team-wella-pancakebox",
    "category": "headshot",
    "alt": "A smiling Joy of Pancakes team member with curly hair and round glasses holds up a custom-illustrated Joy of Pancakes pancake take-home box at the booth.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/headshot/jop_headshot_team-wella-pancakebox.jpg",
    "variants": {
      "600": "press/photos/web/headshot/jop_headshot_team-wella-pancakebox-600.jpg",
      "1200": "press/photos/web/headshot/jop_headshot_team-wella-pancakebox-1200.jpg",
      "2400": "press/photos/web/headshot/jop_headshot_team-wella-pancakebox-2400.jpg"
    }
  },
  {
    "name": "jop_performance_dan-grinning",
    "category": "performance",
    "alt": "Dr. Dan the Pancake Man grins broadly mid-pour while sketching on the griddle, an iPad reference screen above his shoulder.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/performance/jop_performance_dan-grinning.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_dan-grinning-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_dan-grinning-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_dan-grinning-2400.jpg"
    }
  },
  {
    "name": "jop_performance_booth-wide",
    "category": "performance",
    "alt": "The full Joy of Pancakes booth setup — striped canopy with the bold PANCAKE ART sign overhead, Dan at the griddle station, Wella at the poffertjes station, and a young guest watching the action.",
    "featured": true,
    "slot": "hero-anchor",
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/performance/jop_performance_booth-wide.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_booth-wide-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_booth-wide-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_booth-wide-2400.jpg"
    }
  },
  {
    "name": "jop_performance_dan-tj-mario",
    "category": "performance",
    "alt": "Dan and a guest grin at the camera in front of The Joy of Pancakes banner — the guest holds a custom Joy of Pancakes box containing a finished Mario pancake.",
    "featured": true,
    "slot": "clients-anchor",
    "width": 6720,
    "height": 3780,
    "aspect": 1.7777777777777777,
    "original": "press/photos/originals/performance/jop_performance_dan-tj-mario.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_dan-tj-mario-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_dan-tj-mario-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_dan-tj-mario-2400.jpg"
    }
  },
  {
    "name": "jop_performance_teaching-dinosaur",
    "category": "performance",
    "alt": "Dan helps a child squeeze pancake batter onto a hot griddle; a green and orange dinosaur design takes shape in front of them.",
    "featured": false,
    "slot": null,
    "width": 2048,
    "height": 1365,
    "aspect": 1.5003663003663004,
    "original": "press/photos/originals/performance/jop_performance_teaching-dinosaur.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_teaching-dinosaur-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_teaching-dinosaur-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_teaching-dinosaur-2400.jpg"
    }
  },
  {
    "name": "jop_performance_stitch-collab",
    "category": "performance",
    "alt": "Dan and a young guest collaborate on a Stitch pancake — Dan holds the spatula, the child holds a pink squeeze bottle, both focused on the griddle.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/performance/jop_performance_stitch-collab.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_stitch-collab-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_stitch-collab-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_stitch-collab-2400.jpg"
    }
  },
  {
    "name": "jop_performance_family-watching",
    "category": "performance",
    "alt": "A multigenerational family — grandmother, mother, two children — leans in to watch the griddle as a pancake takes shape, eyes wide.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/performance/jop_performance_family-watching.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_family-watching-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_family-watching-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_family-watching-2400.jpg"
    }
  },
  {
    "name": "jop_performance_kid-cheer",
    "category": "performance",
    "alt": "A young guest in heart-shaped pink sunglasses raises both hands beside her face in a moment of full delight as her pancake is revealed.",
    "featured": false,
    "slot": null,
    "width": 2048,
    "height": 2048,
    "aspect": 1,
    "original": "press/photos/originals/performance/jop_performance_kid-cheer.jpg",
    "variants": {
      "600": "press/photos/web/performance/jop_performance_kid-cheer-600.jpg",
      "1200": "press/photos/web/performance/jop_performance_kid-cheer-1200.jpg",
      "2400": "press/photos/web/performance/jop_performance_kid-cheer-2400.jpg"
    }
  },
  {
    "name": "jop_portfolio_rayquaza",
    "category": "portfolio",
    "alt": "A young guest with tousled hair beams while holding up a plate with a finished green Rayquaza dragon pancake.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/portfolio/jop_portfolio_rayquaza.jpg",
    "variants": {
      "600": "press/photos/web/portfolio/jop_portfolio_rayquaza-600.jpg",
      "1200": "press/photos/web/portfolio/jop_portfolio_rayquaza-1200.jpg",
      "2400": "press/photos/web/portfolio/jop_portfolio_rayquaza-2400.jpg"
    }
  },
  {
    "name": "jop_portfolio_basset-portrait",
    "category": "portfolio",
    "alt": "A tattooed hand presents a plate holding a photorealistic pancake portrait of a basset hound on a black-and-white checkered teal background.",
    "featured": false,
    "slot": null,
    "width": 2048,
    "height": 1365,
    "aspect": 1.5003663003663004,
    "original": "press/photos/originals/portfolio/jop_portfolio_basset-portrait.jpg",
    "variants": {
      "600": "press/photos/web/portfolio/jop_portfolio_basset-portrait-600.jpg",
      "1200": "press/photos/web/portfolio/jop_portfolio_basset-portrait-1200.jpg",
      "2400": "press/photos/web/portfolio/jop_portfolio_basset-portrait-2400.jpg"
    }
  },
  {
    "name": "jop_portfolio_eevee-girl",
    "category": "portfolio",
    "alt": "A young girl in heart-shaped pink sunglasses beams while holding a plate with her finished Eevee pancake, gold-painted fingernails curling around the rim.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/portfolio/jop_portfolio_eevee-girl.jpg",
    "variants": {
      "600": "press/photos/web/portfolio/jop_portfolio_eevee-girl-600.jpg",
      "1200": "press/photos/web/portfolio/jop_portfolio_eevee-girl-1200.jpg",
      "2400": "press/photos/web/portfolio/jop_portfolio_eevee-girl-2400.jpg"
    }
  },
  {
    "name": "jop_portfolio_hotdog-grandpa",
    "category": "portfolio",
    "alt": "A grin-from-ear-to-ear older guest in a blue hoodie and aviators holds up a plate with a brightly painted hot dog pancake.",
    "featured": false,
    "slot": null,
    "width": 1536,
    "height": 2048,
    "aspect": 0.75,
    "original": "press/photos/originals/portfolio/jop_portfolio_hotdog-grandpa.jpg",
    "variants": {
      "600": "press/photos/web/portfolio/jop_portfolio_hotdog-grandpa-600.jpg",
      "1200": "press/photos/web/portfolio/jop_portfolio_hotdog-grandpa-1200.jpg",
      "2400": "press/photos/web/portfolio/jop_portfolio_hotdog-grandpa-2400.jpg"
    }
  },
  {
    "name": "jop_portfolio_stitch-girl",
    "category": "portfolio",
    "alt": "A young girl with a ponytail of natural curls grins behind her finished Stitch pancake on a paper plate.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/portfolio/jop_portfolio_stitch-girl.jpg",
    "variants": {
      "600": "press/photos/web/portfolio/jop_portfolio_stitch-girl-600.jpg",
      "1200": "press/photos/web/portfolio/jop_portfolio_stitch-girl-1200.jpg",
      "2400": "press/photos/web/portfolio/jop_portfolio_stitch-girl-2400.jpg"
    }
  },
  {
    "name": "jop_bts_batter-bottles",
    "category": "bts",
    "alt": "A row of squeeze bottles filled with pastel-colored pancake batter; an artist's hand reaches in to select one.",
    "featured": true,
    "slot": "tools-anchor",
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/bts/jop_bts_batter-bottles.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_batter-bottles-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_batter-bottles-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_batter-bottles-2400.jpg"
    }
  },
  {
    "name": "jop_bts_menu-board",
    "category": "bts",
    "alt": "The booth's hand-lettered menu board listing Flash Designs ($10), Custom Designs ($30), and the Pancake Preservation Kit ($20), with Wellamade pancake-themed kandi bracelets on display below.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/bts/jop_bts_menu-board.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_menu-board-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_menu-board-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_menu-board-2400.jpg"
    }
  },
  {
    "name": "jop_bts_kandi-earrings",
    "category": "bts",
    "alt": "A row of Wellamade dangly earrings on display cards — pancakes, waffles, hearts, sunny-side-up eggs — set on a vivid blue tablecloth.",
    "featured": false,
    "slot": null,
    "width": 2048,
    "height": 1365,
    "aspect": 1.5003663003663004,
    "original": "press/photos/originals/bts/jop_bts_kandi-earrings.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_kandi-earrings-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_kandi-earrings-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_kandi-earrings-2400.jpg"
    }
  },
  {
    "name": "jop_bts_poffertjes-loaded",
    "category": "bts",
    "alt": "A boat of poffertjes generously topped with lemon curd, blueberry compote, powdered sugar, and a swirl of purple ube whipped cream.",
    "featured": false,
    "slot": null,
    "width": 2048,
    "height": 1365,
    "aspect": 1.5003663003663004,
    "original": "press/photos/originals/bts/jop_bts_poffertjes-loaded.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_poffertjes-loaded-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_poffertjes-loaded-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_poffertjes-loaded-2400.jpg"
    }
  },
  {
    "name": "jop_bts_poffertjes-cooking",
    "category": "bts",
    "alt": "Golden-brown poffertjes mid-cook in their cast-iron pan; a gloved hand uses bamboo skewers to turn them.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/bts/jop_bts_poffertjes-cooking.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_poffertjes-cooking-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_poffertjes-cooking-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_poffertjes-cooking-2400.jpg"
    }
  },
  {
    "name": "jop_bts_wella-poffertjes-station",
    "category": "bts",
    "alt": "Wella works the poffertjes station mid-shift, turning a tray of golden mini-pancakes with bamboo skewers; Dan is visible at his griddle in the background.",
    "featured": false,
    "slot": null,
    "width": 1365,
    "height": 2048,
    "aspect": 0.66650390625,
    "original": "press/photos/originals/bts/jop_bts_wella-poffertjes-station.jpg",
    "variants": {
      "600": "press/photos/web/bts/jop_bts_wella-poffertjes-station-600.jpg",
      "1200": "press/photos/web/bts/jop_bts_wella-poffertjes-station-1200.jpg",
      "2400": "press/photos/web/bts/jop_bts_wella-poffertjes-station-2400.jpg"
    }
  }
];

export const PRESS_PHOTO_CATEGORIES = ["headshot","performance","portfolio","bts"];

// Lookup helper — find the featured photo for a named layout slot.
export function findSlot(slot) {
  return PRESS_PHOTOS.find((p) => p.slot === slot) || null;
}
